<script>
const sidebarMenu = [
  { path: '/dashboard', icon: 'fa fa-th', title: 'Dashboard' },
  { path: '/eventbank', icon: 'fa fa-database', title: 'Event Bank' },
  { path: '/storyboard', icon: 'fa fa-book', title: 'Storyboard' },
  { path: '/script', icon: 'fa fa-scroll', title: 'Script' },
  { path: '/task', icon: 'fa fa-tasks', title: 'Task' },
  { path: '/budget', icon: 'fa fa-money-bill-wave', title: 'Budget' }
]

export default sidebarMenu
</script>
